module.exports = __webpack_public_path__ + "static/media/chan-avatar.5fd88976.svg";